<template>
  <div class="preloader-container" v-if="!enable">
    <div class="preloader-content">
      <v-progress-circular
        indeterminate
        color="secondary"
        size="48"
        width="4"
      ></v-progress-circular>
      <p class="preloader-text">Chargement...</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    enable: Boolean
  }
};
</script>

<style lang="scss" scoped>
.preloader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  padding: 48px;
}

.preloader-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.preloader-text {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
  margin: 0;
}

.theme--dark .preloader-text {
  color: rgba(255, 255, 255, 0.5);
}
</style>